import { Component } from '@angular/core';

// Composants
import { DialogBaseComponent } from 'src/app/@shared/components/abstract/dialog-base.component';
import { CreateClientFormComponent } from '../create-client-form/create-client-form.component';

// Modèles
import { Client } from 'src/app/@shared/models/client/client.model';

@Component({
    selector: 'app-create-client-dialog',
    imports: [
        CreateClientFormComponent
    ],
    templateUrl: './create-client-dialog.component.html',
    styleUrl: './create-client-dialog.component.scss'
})
export class CreateClientDialogComponent extends DialogBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _client!: Client;
    public get client(): Client {
        return this._client;
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    constructor() {
        super();
        let client = Client.init();
        client.accountingFirm = this.appService.selectedClient;
        this._client = client;
    }

    public onCreated(client: Client): void {
        this._dialogRef!.close();
    }

}
